/**
 * SEO 配置 - models (简体中文)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - 旗舰级 AI 视频生成 | WeryAI',
        description: 'Google Veo 3.1：旗舰级 AI 视频模型，支持原生音频、帧控制与高级场景延展。在 WeryAI 免费创作高品质逼真视频。',
        keywords: 'Google Veo 3.1, 旗舰 AI 视频, AI 视频生成器, 文本转视频, 逼真 AI 视频, 原生音频, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 高品质 AI 视频生成模型 | WeryAI',
        description: 'Google Veo 3 生成高质量、逼真的视频，支持强大的动作一致性与原生音频。在 WeryAI 免费创作专业 AI 视频。',
        keywords: 'Veo 3, Google Veo, AI 视频创作, 动作一致性, 文生视频, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 极速 AI 视频生成 | WeryAI',
        description: '用 Google Veo 3 Fast 快速生成高质量 AI 视频。支持角色一致性与极速渲染。',
        keywords: 'Veo 3 Fast, 极速 AI 视频, 角色一致性, 文本转视频, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 物理模拟级 AI 视频生成 | WeryAI',
        description: '体验 OpenAI Sora 2，生成符合物理规律的超逼真视频。支持多镜头叙事与精准控制。',
        keywords: 'Sora 2, OpenAI Sora, 物理模拟, 逼真 AI 视频, 文本转视频, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - 旗舰级原生 AI 视频生成器 | WeryAI',
        description: 'WeryAI Video 1.0：旗舰级原生 AI 视频模型，支持原生多镜头叙事、智能图生视频与物理级动作模拟。立即免费体验。',
        keywords: 'WeryAI Video 1.0, WeryAI 原生模型, AI 视频生成器, 多镜头叙事, 图生视频, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - 工作室级 AI 图像生成器 | WeryAI',
        description: 'WeryAI Image 2.0：旗舰级 AI 图像模型，支持卓越的文字渲染、超写实细节与毫秒级推理。专业设计触手可及。立即免费体验。',
        keywords: 'WeryAI Image 2.0, 工作室级 AI, AI 图像生成器, 专业 AI 设计, 文生图, 逼真 AI 照片, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 图像生成器 - xAI 超写实 AI 绘画 | WeryAI',
        description: '在 WeryAI 体验 xAI 推出的 Grok-2。基于 Flux.1 架构，呈现惊艳的逼真效果与极速生成。',
        keywords: 'Grok-2, Grok 2 图像生成器, xAI, Flux.1, 逼真 AI, AI 艺术, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - 顶级国产 AI 视频生成器 | WeryAI',
        description: 'Kling 2.5 Turbo 提供卓越的运镜控制与情感表现力。创作电影级 AI 视频的首选。',
        keywords: 'Kling 2.5 Turbo, 可灵 AI, 电影级视频, 运镜控制, 视频生成, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - 专业 AI 视频编辑与生成 | WeryAI',
        description: 'Runway Gen-4 具备深度提示词理解与风格一致性。在 WeryAI 体验下一代 AI 视频编辑。',
        keywords: 'Runway Gen-4, Runway AI, 视频生成器, AI 视频编辑, 文本转视频, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - 电商与动态 AI 视频 | WeryAI',
        description: 'Hailuo 2.3 专为动态动作与电商广告优化。提供细腻的面部微表情与物体运动控制。',
        keywords: 'Hailuo 2.3, 海螺 AI, MiniMax, 电商视频, 动态 AI 视频, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI 视频生成器 - 高级动作控制 | WeryAI',
        description: '使用 Hailuo AI 生成高级 AI 视频。具备顶尖的动作模拟与逼真场景渲染能力。',
        keywords: 'Hailuo AI, 海螺 AI, 动作控制, 逼真视频, 视频生成器, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 高清细腻 AI 动画生成 | WeryAI',
        description: '在 WeryAI 体验 Pika 2.2，生成清晰、锐利的高清 AI 动画。非常适合精细角色创作。',
        keywords: 'Pika 2.2, Pika AI, AI 动画, 高清视频, 视频生成器, WeryAI',
    },
    seedance: {
        title: 'Seedance 1.0 Pro - AI 舞蹈与动作视频 | WeryAI',
        description: '用 Seedance 1.0 Pro 创作丝滑的一致性舞蹈视频。支持动态运镜与多镜头切换。',
        keywords: 'Seedance, 字节跳动 AI, AI 舞蹈, 动作生成, 视频模型, WeryAI',
    },
    wan_ai: {
        title: 'Wan 2.5 - 阿里顶级多模态视频大模型 | WeryAI',
        description: '阿里 Wan 2.5 支持多模态输入与动态动作渲染。创作高保真 AI 视频内容。',
        keywords: 'Wan 2.5, 阿里 AI, 多模态视频, 动作渲染, 视频生成器, WeryAI',
    },
    wan_2_6: {
        title: 'Wan 2.6 - 电影级 1080p AI 视频生成 | WeryAI',
        description: 'Wan 2.6 提供 1080p 电影级画质与原生音画同步。阿里最新多模态旗舰模型。',
        keywords: 'Wan 2.6, 阿里 AI, 1080p 视频, 音画同步, 多模态模型, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - 谷歌 Gemini 3.0 Pro 图像生成 | WeryAI',
        description: '基于推理驱动的 AI 图像大模型，支持 4K 超写实画画质与完美文字排版。免费体验顶级国产 AI 绘图技术。',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, AI 绘图, 4K 图像生成, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash 极速绘图 | WeryAI',
        description: '由谷歌 DeepMind 开发的极速、高一致性 AI 图像生成器。支持自然语言编辑与多图融合。',
        keywords: 'Nano Banana, Gemini 2.5 Flash, 极速绘图, 角色一致性, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI 图像生成器 - 顶尖开源绘图大模型 | WeryAI',
        description: 'FLUX 由原 Stable Diffusion 团队开发，提供卓越的视觉质量与精准的提示词遵循能力。',
        keywords: 'FLUX, 黑森林实验室, AI 绘画, 文生图, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - 专业级 AI 绘图增强版 | WeryAI',
        description: '体验 FLUX.1 Pro 与 Max 版本，具备更强的文字渲染与角色一致性。专为设计师与创意专业人士打造。',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, 专业绘图, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - 谷歌高级文本转图像扩散模型 | WeryAI',
        description: '生成摄影级、艺术化与抽象派图像。谷歌 Imagen 4 提供多样化的风格控制与高质量渲染。',
        keywords: 'Imagen 4, 谷歌 AI 绘画, 扩散模型, 艺术生成, WeryAI',
    },
    image_gpt_4o: {
        title: 'GPT-4o 图像生成 - OpenAI 对话式 AI 绘画 | WeryAI',
        description: '通过对话创建并微调图像。GPT-4o 提供精准的文字渲染与高保真视觉效果。',
        keywords: 'GPT-4o, OpenAI 绘画, 对话式绘图, DALL-E 3 代替, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image (千问图像) - 阿里开源文本渲染模型 | WeryAI',
        description: '阿里千问图像模型专注于多语言文字渲染与风格化创作。免费生成专业级视觉素材。',
        keywords: 'Qwen Image, 通义千问, 阿里 AI 绘画, 多语言文字, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 图像生成 - 阿里高保真文生图大模型 | WeryAI',
        description: 'Wan 2.5 支持精准提示词遵循与摄影级渲染能力。阿里最新高保真 AI 绘图技术。',
        keywords: 'Wan AI, Wan 2.5, 阿里 AI 绘图, 高保真图像, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - 字节跳动批量化 4K 绘图模型 | WeryAI',
        description: '字节跳动推出的极速绘图模型，支持批量处理与 4K 高清渲染。具备强大的一致性角色控制能力。',
        keywords: 'Seedream, 字节跳动 AI, 批量绘图, 4K 图像, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - 字节跳动全能 AI 图像创作模型 | WeryAI',
        description: 'Dreamina 4.0 支持手绘转图像、风格迁移与多角色融合。字节跳动顶尖商用绘图大模型。',
        keywords: 'Dreamina 4.0, 即梦 AI, 手绘变图像, 风格迁移, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - 字节跳动旗舰级 AI 图像生成模型 | WeryAI',
        description: 'Seedream 4.5 是字节跳动最新推出的旗舰级 AI 图像模型，专注于精准文字渲染与多图融合，支持4K超清画质输出。立即在 WeryAI 免费体验。',
        keywords: 'Seedream 4.5, AI图像生成, 文字渲染, 多图融合, 字节跳动, 4K画质, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - 灵活、细腻且充满活力的图像生成 | WeryAI',
        description: 'Midjourney 是由独立研究实验室推出的旗舰级 AI 图像模型，以极致艺术审美与光影质感著称。立即在 WeryAI 免费体验。',
        keywords: 'Midjourney, AI图像生成, 艺术创作, 光影质感, 文字渲染, 超写实人像, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI 视频生成器 - 创作电影级视频 | WeryAI',
        description: '在 WeryAI 上使用 Runway Gen-4.5 创作惊艳视频。采用自回归扩散混合架构，提供精准的物理模拟和时序一致性。',
        keywords: 'Runway Gen-4.5, AI视频生成器, 电影级AI视频, 物理模拟, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI 视频生成器 - 高质量视频创作 | WeryAI',
        description: '在 WeryAI 上使用 Kling 2.6 Pro 生成高质量视频。体验增强的视频真实感、运动一致性和提示词遵循度。',
        keywords: 'Kling 2.6 Pro, AI视频生成器, 高质量AI视频, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 视频生成器 - 精确的摄像机控制和首尾帧指导 | WeryAI',
        description: '在 WeryAI 使用 Dreamina 3.0（即梦 3.0）生成电影级 AI 视频。支持首尾帧精确控制、专业运镜和 1080p 高动态视频生成。',
        keywords: 'Dreamina 3.0, 即梦3.0, AI视频生成器, 运镜控制, 首尾帧控制, 字节跳动AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI 视频生成器 - 创意视频生成 | WeryAI',
        description: '在 WeryAI 上释放您的创造力，使用 Kling O1 AI 视频生成器。非常适合生成充满想象力和独特的视频内容。',
        keywords: 'Kling O1, AI视频生成器, 创意AI视频, Kling AI, WeryAI',
    },
}
